    angular.module('sessionTimeoutInterceptor', [])
        .config(function ($httpProvider) {
            $httpProvider.interceptors.push('sessionTimeoutInterceptor');
            $httpProvider.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';
            //enable CSRF
            $httpProvider.defaults.xsrfCookieName = 'CSRF-TOKEN';
            $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-TOKEN';
            $httpProvider.useApplyAsync(true);
        })
        .factory('sessionTimeoutInterceptor', function ($q, $state, $injector, $document) {
            var identityRefreshInFlight;
            return {
                'response': function (response) {
                    if (response && response.headers && response.headers('X-Authorities-Refreshed') === '1') {
                        var Principal = $injector.get('Principal');
                        var $rootScope = $injector.get('$rootScope');
                        if (!identityRefreshInFlight) {
                            identityRefreshInFlight = Principal.identity(true).then(function () {
                                $rootScope.$broadcast('authenticationChanged');
                            }).finally(function () {
                                identityRefreshInFlight = undefined;
                            });
                        }
                    }
                    return response;
                },
                'responseError': function (response) {
                    var currentUserRequestUrl = '/crm/api/account/current-account';
                    var isCurrentUserRequest = response && response.config && response.config.url && response.config.url.indexOf(currentUserRequestUrl) !== -1;

                    if (response.status === 401 && !isCurrentUserRequest) {
                        var Principal = $injector.get('Principal');
                        Principal.identity(true).then(function (account) {
                            if(account == null){
                                var $uibModalStack = $injector.get('$uibModalStack');
                                $uibModalStack.dismissAll('session-expired');
                                $state.go('login');
                            }
                        });
                    }
                    else if (response.status === 403 && response.config.method !== 'GET' && getCSRF() === '') {
                        // If the CSRF token expired, then try to get a new CSRF token and retry the old request
                        var $http = $injector.get('$http');
                        return $http.get('/').finally(function () {
                            return afterCSRFRenewed(response);
                        });
                    }
                    return $q.reject(response);
                }
            };

            function getCSRF() {
                var doc = $document[0];
                if (doc) {
                    var name = 'CSRF-TOKEN=';
                    var ca = doc.cookie.split(';');
                    for (var i = 0; i < ca.length; i++) {
                        var c = ca[i];
                        while (c.charAt(0) === ' ') {
                            c = c.substring(1);
                        }

                        if (c.indexOf(name) !== -1) {
                            return c.substring(name.length, c.length);
                        }
                    }
                }
                return '';
            }

            function afterCSRFRenewed(oldResponse) {
                if (getCSRF() !== '') {
                    // retry the old request after the new CSRF-TOKEN is obtained
                    var $http = $injector.get('$http');
                    return $http(oldResponse.config);
                } else {
                    // unlikely get here but reject with the old response any way and avoid infinite loop
                    return $q.reject(oldResponse);
                }
            }
        });
